<template>
    <div class="container">
        <el-dialog
            title="修改密码"
            :visible.sync="editPwObj.visible"
            width="400px"
            append-to-body
        >
            <el-form
                ref="editPwForm"
                :model="editPwObj.form"
                :rules="editPwObj.rules"
                label-position="left"
                label-width="100px"
            >

                <el-form-item
                    label="旧密码"
                    prop="OldPassword"
                >
                    <el-input
                        v-model="editPwObj.form.OldPassword"
                        placeholder="请输入旧密码"
                        show-password
                    />
                </el-form-item>
                <el-form-item
                    label="新密码"
                    prop="Password"
                >
                    <el-input
                        v-model="editPwObj.form.Password"
                        placeholder="请输入新密码"
                        show-password
                    />
                </el-form-item>
                <el-form-item
                    label="确认密码"
                    prop="PasswordCheck"
                >
                    <el-input
                        v-model="editPwObj.form.PasswordCheck"
                        placeholder="请再次输入新密码"
                        show-password
                    />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    @click="submitForm('editPwForm')"
                >确 定</el-button>
                <el-button @click="editPwObj.visible=false">取 消</el-button>
            </div>
        </el-dialog>
        <div class="topBar">
            <div class="prjTitle">
                <div>
                    <el-button
                        @click="isCollapse=!isCollapse"
                        :icon="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"
                        circle
                    ></el-button>
                </div>
                <span :class="{'hiddenTitle':isCollapse}">网关配置管理平台</span>
            </div>
            <div class="prjTools">
                <el-dropdown
                    @command="handleCommand"
                    trigger="click"
                >
                    <span class="el-dropdown-link">
                        {{UserName}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="editPwd">修改密码</el-dropdown-item>
                        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="mainContent">
            <el-menu
                class="leftMenu"
                :collapse="isCollapse"
                :default-active="activeMenu"
                :unique-opened="true"
                router
            >
                <menuTree :isCollapse="isCollapse" :menu="Role===2?prjAuth:Role == 3?deviceAuth:mainAuth" />
            </el-menu>
            <div class="rightContent">
                <transition
                    name="changeMenu"
                    mode="out-in"
                >
                    <router-view />
                </transition>

            </div>
        </div>

    </div>
</template>
<script>
import { mapGetters } from "vuex";
import mainAuth from "@/utils/auth/mainAuth";
import prjAuth from "@/utils/auth/prjAuth";
import deviceAuth from "@/utils/auth/deviceAuth";
import menuTree from "@/components/MenuTree";
export default {
    data() {
        return {
            editPwObj: {
                visible: null,
                form: {},
                rules: {
                    OldPassword: [
                        {
                            required: true,
                            message: "请输入旧密码",
                            trigger: "blur",
                        },
                    ],
                    Password: [
                        {
                            required: true,
                            message: "请输入新密码",
                            trigger: "blur",
                        },
                    ],
                    PasswordCheck: [
                        {
                            required: true,
                            message: "请再次输入新密码",
                            trigger: "blur",
                        },
                    ],
                },
            },
            isCollapse: false,
            mainAuth,
            prjAuth,
            deviceAuth,
        };
    },
    components: { menuTree },
    computed: {
        ...mapGetters(["SessionId", "UserId", "Role", "UserName"]),
        activeMenu() {
            // 获取path地址
            const path = this.$route.path;
            // 判断path地址是否是以/xxx开头的(/xxx 为对应显示的一级路由的导航的路由地址)，如果是以这个开头，默认选中某个导航栏
            // if (path.startsWith("/adminLogin/home/genealogy_details")) {
            //     // 如果是则返回一级路由的导航的路由地址
            //     return "/adminLogin/home/genealogy";
            // }
            return path;
        },
    },
    mounted() {},
    methods: {
        handleCommand(command) {
            if (command == "logout") {
                this.logout();
            }
            if (command == "editPwd") {
                this.toEditPwd();
            }
        },
        toEditPwd() {
            this.editPwObj.form = {
                OldPassword: null,
                Password: null,
                PasswordCheck: null,
            };
            if (this.$refs["editPwForm"]) {
                this.$refs["editPwForm"].resetFields();
            }
            this.editPwObj.visible = true;
        },
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if (formName == "editPwForm") {
                        let obj = {
                            SessionId: this.SessionId,
                            UserId: this.UserId,
                            ClientName: "Hoko.Iot.Web.System",
                            Params: {
                                OldPassword: this.$md5(this.editPwObj.form.OldPassword),
                                Password: this.$md5(
                                    this.editPwObj.form.Password
                                ),
                                PasswordCheck: this.$md5(
                                    this.editPwObj.form.PasswordCheck
                                ),
                            },
                        };
                        const res = await this.$api.axios_http(
                            this.$gd.EditPwd,
                            obj,
                            "POST"
                        );
                        if (res.ReturnCode == 0) {
                            this.$message.success("修改成功");
                            this.editPwObj.visible = false;
                        } else {
                            this.$message.error(res.Error);
                        }
                    }
                } else {
                    return false;
                }
            });
        },
        async logout() {
            let obj = {
                SessionId: this.SessionId,
                UserId: this.UserId,
                ClientName: "Hoko.Iot.Web.System",
            };
            const res = await this.$api.axios_http(
                this.$gd.Logout,
                obj,
                "POST"
            );
            if (res.ReturnCode == 0) {
                this.$message.success("退出成功");
                this.$store.commit("user/SET_USERINFO", {});
                localStorage.removeItem("userInfo");
                this.$router.push("/adminLogin");
            } else {
                this.$message.error(res.Error);
            }
        },
    },
};
</script>
<style scoped lang="scss">
.changeMenu-leave-active,
.changeMenu-enter-active {
    transition: all 0.3s;
}

.changeMenu-enter {
    opacity: 0;
    transform: translateX(-30px);
}

.changeMenu-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .topBar {
        height: 80px;
        line-height: 80px;
        background: #2c86d1;
        color: white;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        // padding: 0 20px;
        .prjTitle {
            display: flex;
            align-items: center;
            div {
                width: 64px;
                text-align: center;
            }
            span {
                font-size: 24px;
                margin-left: 5px;
                transition: all 0.4s;
                &.hiddenTitle {
                    opacity: 0;
                }
            }
        }
        .prjTools {
            margin-right: 20px;
        }
        .el-dropdown-link {
            cursor: pointer;
            color: white;
        }
    }
    .mainContent {
        display: flex;
        height: 0;
        flex: 1;
        .leftMenu {
            box-shadow: 0px 5px 5px #e6e6e6;
        }
        .leftMenu:not(.el-menu--collapse) {
            width: 220px;
            flex-shrink: 0;
        }
        .rightContent {
            width: 0;
            flex: 1;
            background: #f5f7fa;
            overflow: hidden;
        }
    }
}
</style>
